//#region src/core/source/tiktok.ts
/**
* Extract a TikTok video id from a raw numeric id or any recognized URL.
*
* @internal
*/
function parseTikTokVideoId(src) {
	return parseTikTokSource(src)?.id ?? null;
}
/**
* Parse a TikTok source string. Recognizes raw numeric ids, `player/v1/` embed URLs, `share/video/` links, and the
* `@user/video/` URLs the app hands out.
*
* @internal
*/
function parseTikTokSource(src) {
	if (!src) return null;
	if (MATCH_ID.test(src)) return { id: src };
	const id = MATCH_SRC.exec(src)?.[1];
	return id ? { id } : null;
}
const MATCH_ID = /^\d+$/;
const MATCH_SRC = /tiktok\.com\/(?:player\/v1\/|share\/video\/|@[^/]+\/video\/)(\d+)/;
//#endregion
export { parseTikTokSource, parseTikTokVideoId };
